export default __webpack_public_path__ + "static/rightmob-1576d9b78ec9e998ffb3ad993fde8dc9.png";